import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useDisableCarrierConfigQuery = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    async (carrierId: string) => api.patch(API_URL.CARRIER_CONFIGS_DISABLE_BY_ID(carrierId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.CARRIER_CONFIGS],
        });
        if (onSuccess) onSuccess();
      },
    }
  );

  return {
    disableCarrierConfig: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useDisableCarrierConfigQuery;
